import React, { useEffect } from "react";
import { Helmet } from "@dr.pogodin/react-helmet";
import { Link, useLocation } from "react-router-dom";
import WebDesignBanner from "../../components/HeaderWithAd/HeaderWithAd";
import NeonButton from "../../components/ResponsiveButton/NeonButton.jsx";
import { motion } from "../../lib/motionSafe"; // polku suhteessa komponenttiin

export default function NotFound() {
  const loc = useLocation();

  // Ilmoita otsikko headerille (yhtenevä Etusivun kanssa analytiikkaa varten)
  useEffect(() => {
    const title = "Sivua ei löytynyt (404) | Buukkeri";
    const path = `${loc.pathname}${loc.search || ""}`;
    window.dispatchEvent(new CustomEvent("bbx:title", { detail: { title, path } }));
  }, [loc.pathname, loc.search]);

  return (
    <>
      <Helmet>
        <title>Sivua ei löytynyt (404) | Buukkeri</title>
        <meta
          name="description"
          content="Etsimääsi sivua ei löytynyt. Palaa etusivulle tai avaa pikahaku ja etsi vapaat esiintyjät."
        />
        {/* 404: noindex,follow ilman canonicalia */}
        <meta name="robots" content="noindex,follow" />
      </Helmet>

      <WebDesignBanner>
        <div className="text-center">
          <motion.h1
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="font-customFont1 text-3xl md:text-4xl text-white/85 dark:text-white/85 text-shadow-lg"
          >
            Sivua ei löytynyt..
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.08 }}
            className="mt-3 text-xs md:text-lg text-white/80 pb-4 text-shadow-md"
          >
            Linkki on voinut muuttua tai poistua. Pääset alta nopeasti eteenpäin.
          </motion.p>
        </div>

        <div className="relative z-30 mx-auto w-full max-w-3xl rounded-2xl p-6 bg-lemon/60 dark:bg-black/40 backdrop-blur-md shadow-lg ring-1 ring-white/40">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/" className="w-full sm:w-auto">
              <NeonButton variant="primary" size="md" className="w-full">
                ← Etusivulle
              </NeonButton>
            </Link>

          </div>

          <p className="mt-4 text-center text-xs md:text-lg dark:text-white/80 text-black/80 font-semibold">
            Jos ongelma jatkuu tai tässä osoitteessa pitäisi olla mielestäsi jotain, laita viestiä:{" "}
            <a href="mailto:info@buukkeri.fi" className="underline">
              info@buukkeri.fi
            </a>
          </p>
        </div>
      </WebDesignBanner>
    </>
  );
}
